"use client";

import PublicHeader from "@/components/PublicHeader";
import Footer from "@/components/Footer";
import {
  Container,
  Content,
  ContentWrapper,
  Title,
  Section,
  SectionTitle,
  Paragraph,
  StepContainer,
  Step,
  StepNumber,
  StepTitle,
  StepDescription,
  List,
  ListItem,
  CTASection,
  CTATitle,
  CTAButton,
} from "./page.styles";

export default function HowItWorksPage() {
  return (
    <Container>
      <PublicHeader />

      <Content>
        <ContentWrapper>
          <Title>How It Works</Title>
          <Paragraph>
            Ordering authentic homemade meals on Drizl is simple! Whether
            you&apos;re looking for your next favorite meal or wanting to share
            your culinary creations, here&apos;s how to get started.
          </Paragraph>

          <Section>
            <SectionTitle>For Customers</SectionTitle>
            <StepContainer>
              <Step>
                <StepNumber>1</StepNumber>
                <StepTitle>Browse Meals</StepTitle>
                <StepDescription>
                  Explore a diverse selection of homemade meals from talented
                  local artisans. Filter by cuisine, dietary preferences, price
                  range, and more to find exactly what you&apos;re craving.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>2</StepNumber>
                <StepTitle>Select & Customize</StepTitle>
                <StepDescription>
                  Choose your favorite meals, customize options (portion size,
                  spice level, etc.), and add them to your cart. Read reviews
                  and see what other food lovers are saying.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>3</StepNumber>
                <StepTitle>Place Your Order</StepTitle>
                <StepDescription>
                  Complete your order with secure payment. Choose between pickup
                  or delivery, select your preferred time, and add any special
                  instructions for the artisan.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>4</StepNumber>
                <StepTitle>Track & Receive</StepTitle>
                <StepDescription>
                  Get real-time updates as your meal is being prepared. Receive
                  notifications when it&apos;s ready for pickup or out for
                  delivery. Enjoy your delicious homemade meal!
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>5</StepNumber>
                <StepTitle>Review & Enjoy</StepTitle>
                <StepDescription>
                  Share your experience by leaving a review. Your feedback helps
                  artisans improve and helps other customers discover great
                  meals. Don&apos;t forget to order again!
                </StepDescription>
              </Step>
            </StepContainer>
          </Section>

          <Section>
            <SectionTitle>For Artisans</SectionTitle>
            <StepContainer>
              <Step>
                <StepNumber>1</StepNumber>
                <StepTitle>Sign Up & Get Started</StepTitle>
                <StepDescription>
                  Create your artisan account and start creating your meals.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>2</StepNumber>
                <StepTitle>Create Your Menu</StepTitle>
                <StepDescription>
                  Add your delicious meals with mouthwatering photos and
                  detailed descriptions. Set your own prices, indicate dietary
                  information, and showcase what makes your cooking special.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>3</StepNumber>
                <StepTitle>Manage Orders</StepTitle>
                <StepDescription>
                  Receive order notifications through the app. Accept orders
                  that fit your schedule, communicate with customers, and manage
                  everything from your dashboard.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>4</StepNumber>
                <StepTitle>Prepare & Fulfill</StepTitle>
                <StepDescription>
                  Cook your meals with the same love and care you always do.
                  Update order status as you prepare, package securely for
                  pickup or delivery, and maintain your quality standards.
                </StepDescription>
              </Step>

              <Step>
                <StepNumber>5</StepNumber>
                <StepTitle>Get Paid & Grow</StepTitle>
                <StepDescription>
                  Receive payments directly to your bank account. Build your
                  reputation through positive reviews, attract repeat customers,
                  and grow your home food business with Drizl.
                </StepDescription>
              </Step>
            </StepContainer>
          </Section>

          <Section>
            <SectionTitle>Why Drizl Works</SectionTitle>
            <List>
              <ListItem>
                Safe and secure platform with verified artisans
              </ListItem>
              <ListItem>
                Easy-to-use interface for both customers and artisans
              </ListItem>
              <ListItem>
                Flexible scheduling – order when it&apos;s convenient for you
              </ListItem>
              <ListItem>Real-time order tracking and updates</ListItem>
              <ListItem>
                Secure payment processing with buyer and seller protection
              </ListItem>
              <ListItem>
                Direct communication between customers and artisans
              </ListItem>
              <ListItem>
                Rating and review system for quality assurance
              </ListItem>
              <ListItem>Support for local food communities</ListItem>
            </List>
          </Section>

          <CTASection>
            <CTATitle>Ready to Get Started?</CTATitle>
            <Paragraph
              style={{
                color: "white",
                fontSize: "1.2rem",
                marginBottom: "2rem",
              }}
            >
              Join thousands of food lovers and talented artisans on Drizl
              today!
            </Paragraph>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <CTAButton href="/register">Sign Up as Customer</CTAButton>
              <CTAButton href="/artisan-onboarding">
                Become an Artisan
              </CTAButton>
            </div>
          </CTASection>
        </ContentWrapper>
      </Content>

      <Footer />
    </Container>
  );
}
